module.exports = __webpack_public_path__ + "img/case-bg-2.a3094b89.png";